import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import FormHeader from 'components/global/FormHeader';
import { HeaderContainerFormHeader } from 'components/global/styled/FormHeader.styled';
import DynamicList from 'components/list/DynamicList';
import { FilterAction, FilterType, ListComponents } from 'components/list/DynamicListFilterUtils';

import { ADMIN, ENUMS } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';
import PATHS, { mergePaths } from 'utils/paths';

import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';

const PickupCities = () => {
	const [searchParams] = useSearchParams();
	const id = searchParams.get('id');

	const defaultSort = useMemo(() => [{ id: 'dcsPickupCitiesID', desc: true }], []);

	const defaultFilters = useMemo(
		() => [
			{
				column: {
					Header: 'dcSettingsID',
					accessor: 'dcSettingsID',
					filterType: FilterType.number,
					filterVisible: false
				},
				action: FilterAction.contains,
				value: id
			}
		],
		[id]
	);

	const columns = useMemo(
		() => [
			{
				Header: 'dcsPickupCitiesID',
				accessor: 'dcsPickupCitiesID',
				filterType: FilterType.number,
				showOnMobile: true
			},
			{
				Header: 'cityID',
				accessor: 'cityId',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'cityName',
				accessor: 'cityName',
				filterType: FilterType.string,
				showOnMobile: true
			},
			{
				Header: 'country',
				accessor: 'country',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.COUNTRIES,
				filterPrefix: 'country.',
				renderCell: ListComponents.COUNTRY,
				showOnMobile: true
			},
			{
				Header: 'active',
				accessor: 'active',
				filterType: FilterType.enumMulti,
				enumName: ENUMS.ACTIVE_INACTIVE,
				renderCell: ListComponents.STATUS
			}
		],
		[]
	);

	return (
		<div>
			<HeaderContainerFormHeader>
				<FormHeader
					boldTitle="pickupCities"
					icon={faArrowLeft}
					backUrl={mergePaths(PATHS.DELIVERY_COMPANY_MODULE, PATHS.DELIVERY_COMPANY_SETTINGS)}
				/>
			</HeaderContainerFormHeader>
			<DynamicList
				id={DYNAMICLISTS.PICKUP_CITIES}
				columns={columns}
				fetchUrl={ADMIN.DELIVERY_COMPANY_SETTINGS.GET_PICKUP_CITIES}
				defaultFilters={defaultFilters}
				exportName="pickupCities"
				defaultSort={defaultSort}
				actionObjectType={ACTION_OBJECT_TYPES.ADMIN}
			/>
		</div>
	);
};

export default PickupCities;
